import React, { useState, useEffect } from "react";
import CreatableSelect from 'react-select/creatable';





const ToggleButton = ({isChecked, handleIsCheckedChange}) => {


  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        id="toggleButton"
        className="hidden"
        checked={isChecked}
        onChange={handleIsCheckedChange}
      />
      <label
        htmlFor="toggleButton"
        className="relative flex items-center cursor-pointer select-none"
      >
        <div className={`w-12 h-6 rounded-full shadow-inner  border-2
        ${
          isChecked ? 'border-green-400' : 'border-red-400'
        }
        `}></div>
        <div
          className={`toggle-dot absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform ${
            isChecked ? 'ml-6 bg-green-400 ' : 'ml-0 bg-red-400 '
          }`}
        ></div>
      </label>
    </div>
  );
};


const AddFeatureFlagForm = (props) => {

  const [selectedNameOption, setSelectedNameOption] = useState("");
  const [selectionOptions, setSelectionOptions] = useState([]);
  const [isChecked, setIsChecked] = useState(true);



  useEffect(() => {
    if (props.feature_flag_name_list) {

      var feature_flag_name_array = []
      props.feature_flag_name_list.map((element, index) => {
        feature_flag_name_array.push({value: element, label: element});
      })
      setSelectionOptions(feature_flag_name_array)  
    }

  }, []);


  const handleIsCheckedChange = () => {
    setIsChecked(!isChecked);
  };

  const handleSelectChange = (value) => {
    setSelectedNameOption(value)
  };
  

  return (
    <div>
      <div className="grid sm:grid-cols-6 gap-4 grid-cols-1 w-full items-center">

        <div className="sm:col-span-2 col-span-1">
          <h3 className="whitespace-nowrap">Feature Name*</h3>
        </div> 

        <div className="sm:col-span-4 col-span-1">
          <input 
            type="hidden" 
            name="feature_flag[name]" 
            id="feature_flag_name"
            value={selectedNameOption? selectedNameOption.value: ""} 
          />
          <CreatableSelect 
            className="w-full" 
            isClearable options={selectionOptions} 
            onChange={handleSelectChange}
          />
        </div>
        
        <div className="sm:col-span-2 col-span-1">
          <h3 className="whitespace-nowrap pr-6">Enabled</h3>
        </div>
        
        <div className="w-full sm:col-span-4 col-span-1">
            <ToggleButton 
              isChecked={isChecked}
              handleIsCheckedChange={handleIsCheckedChange}
            />

            <input type="hidden"  id="feature_flag_enabled" name="feature_flag[enabled]" value={isChecked? 1:0}/>
        </div>


      </div>
      
    </div>
  );
};

export default AddFeatureFlagForm;